import { useState, useEffect } from "react";
import queryString from "query-string";
import { isEqual } from "lodash";

function useQueryState(field, defaultValue) {
	const queryParams = queryString.parse(window.location.search);
	const valueFromUrl = queryParams[field];
	const [value, setValue] = useState(valueFromUrl || defaultValue);
	useEffect(() => {
		if (isEqual(value, valueFromUrl)) {
			return;
		}

		const url = new URL(window.location.href);
		url.search = `?${queryString.stringify({
			...queryParams,
			[field]: value,
		})}`;
		window.history.replaceState({ path: url.href }, "", url.href);
	}, [field, value, valueFromUrl, queryParams]);

	return [value, setValue];
}

export default useQueryState;
